import { useRef } from 'react';
import css from './MainProperties.module.scss';
import classNames from 'classnames';
import { Img, svgSprite } from '../../../../../../../hybrid/wrappers';
import parse from 'html-react-parser';
import T from '../../../../../../../common/components/T';

const Property = ({ property, id, setProperties, isSet }) => {
    const contentRef = useRef(null);

    const openProperty = (property) => {
        if (isSet && !property?.description) {
            return;
        }
        setProperties((s) => ({
            ...s,
            left: s?.left?.map((prop) => {
                if (prop.id === property?.id) {
                    return {
                        ...prop,
                        opened: !prop?.opened
                    };
                }
                return prop;
            })
        }));
    };

    return (
        <div key={id} className={classNames(css.mainPropertyWrapper, isSet && css.mainPropertyWrapperSet)}>
            <div
                onClick={() => openProperty(property)}
                className={classNames(css.mainProperty, { [css.mainPropertyOpened]: property.opened })}
            >
                {isSet ? (
                    <div className={css.mainPropertySetLeft}>
                        <div className={css.mainPropertySetImage}>
                            {property?.image?.links?.preview ? (
                                <Img src={property?.image?.links?.preview} alt='Image' />
                            ) : (
                                svgSprite('product-no-image')
                            )}
                        </div>
                        <div className={css.mainPropertySetInfo}>
                            <p className={css.mainPropertySetTitle}>{property?.name}</p>
                        </div>
                    </div>
                ) : (
                    <p className={css.mainPropertyTitle}>{property.title}</p>
                )}
                <div className={classNames(css.mainPropertyIcon, { [css.dn]: isSet && !property?.description })}>
                    {svgSprite(property?.opened ? 'minus' : 'plus')}
                </div>
            </div>
            <div
                className={classNames(css.mainPropertyContent, {
                    [css.mainPropertyContentOpened]: property.opened,
                    [css.dn]: isSet && !property?.description
                })}
                ref={contentRef}
                style={{
                    height: property.opened ? `${contentRef.current.scrollHeight}px` : '0px'
                }}
            >
                {parse(isSet ? property?.description || '' : property?.value?.[0])}
            </div>
        </div>
    );
};

export default function MainProperties({ properties, setProperties, dataProduct }) {
    const isSet = dataProduct?.type === 'set';
    return (
        <div className={classNames(css.mainProperties, { [css.dn]: properties?.left?.length === 0 })}>
            {isSet ? (
                <p className={css.setProductsTitle}>
                    <T textName='filling_the_business_kit' defaultStr='Наполнение бизнес комплекта' />
                </p>
            ) : null}
            {properties?.left
                ? properties?.left?.map((property) => (
                      <Property
                          isSet={isSet}
                          property={property}
                          id={property.id}
                          key={property.id}
                          setProperties={setProperties}
                      />
                  ))
                : null}
        </div>
    );
}
